module.exports = __webpack_public_path__ + "img/pamm-2.f0d0d64-zh.b74aac41.png";